import moment from 'moment';

import {BenchlingAction} from 'redux-stores/Action';
import {getStore} from 'redux-stores/Store';

import {DocumentEditorLockActionType, documentEditorLockClear} from './DocumentEditorLockReduxActions';

export interface DocumentEditorLockState {
  [fileId: string]: DocumentEditorLock;
}

export interface DocumentEditorLock {
  clientId: string;
  userId: string;
  expiresAt: Date;
}

const INITIAL_STATE: DocumentEditorLockState = {};

export default function reduceDocumentEditorLockState(
  state: DocumentEditorLockState = INITIAL_STATE,
  action: BenchlingAction
): DocumentEditorLockState {
  switch (action.type) {
    case DocumentEditorLockActionType.UPDATE_LOCK:
      // Attempt to clear the lock at the expected expiry time
      setTimeout(() => {
        getStore().dispatch(documentEditorLockClear(action.fileId));
      }, action.msUntilExpiration + 1);

      return {
        ...state,
        [action.fileId]: {
          userId: action.userId,
          clientId: action.clientId,
          expiresAt: moment().add(action.msUntilExpiration, 'milliseconds').toDate(),
        },
      };
    case DocumentEditorLockActionType.CLEAR_LOCK:
      // Clear the lock if it is expired or if forced
      if (
        action.force ||
        (state[action.fileId] && moment(state[action.fileId].expiresAt).isBefore(moment()))
      ) {
        const newState = {...state};
        delete newState[action.fileId];
        return newState;
      }
      return state;
    default:
      return state;
  }
}
